export const IN_PROGRESS = "IN_PROGRESS";
export const COMPLETED = "COMPLETED";

export const INITIAL = "INITIAL";
export const FOLLOW_UP = "FOLLOW_UP";
